import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';

const appName = import.meta.env.VITE_APP_NAME || 'Да, България';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.jsx`,
            import.meta.glob('./Pages/**/*.jsx'),
        ),
    setup({ el, App, props }) {
        const root = createRoot(el);
        // Expose translations globally for the simple __ helper
        if (props?.initialPage?.props?.translations) {
            window.__translations = props.initialPage.props.translations;
            window.__locale = props.initialPage.props.locale;
        }

        root.render(<App {...props} />);
    },
    progress: {
        color: '#4B5563',
    },
});
